export const STRINGS = {
  app: {
    name: 'Connexa',
    tagline: 'Exchange professional contacts securely',
  },
  qr: {
    exchangeContacts: 'Exchange Contacts',
    instantConnect: 'Instant Connect',
    downloadIOS: 'Download for iPhone',
    downloadAndroid: 'Download for Android',
    loading: 'Loading…',
    linkInactive: 'This link is no longer active',
    linkInactiveDesc: 'The QR code may have been regenerated or expired.',
    contactSent: 'Contact sent!',
    contactSentDesc: 'Check your email for their details.',
    errorGeneric: 'Something went wrong. Please try again.',
    errorRateLimit: 'Too many requests. Please try again later.',
  },
  profile: {
    loading: 'Loading…',
    expired: 'This profile link has expired.',
    expiredDesc: 'Download Connexa to reconnect.',
    invalid: 'This link is no longer valid.',
    downloadCta: 'Download Connexa',
    availableUntil: 'Profile available until',
  },
  form: {
    title: 'Exchange Contacts',
    shareMyContact: 'Share my contact',
    sending: 'Sending…',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    note: 'Note',
    firstNamePlaceholder: 'Alex',
    lastNamePlaceholder: 'Johnson',
    emailPlaceholder: 'alex@example.com',
    phonePlaceholder: '+1 555 000 0000',
    notePlaceholder: 'How we met…',
  },
} as const
